import { createBrowserApi } from './createBrowserApi';

import { persistAuthTokens, readAuthTokens } from '@/shared/utils';

/** The session's API in the browser: sends the saved token and refreshes it when it expires. */
export const browserApi = createBrowserApi({
    getTokens: readAuthTokens,
    onTokensRefreshed: persistAuthTokens,
    onRefreshFailed: () => persistAuthTokens(null),
});
